var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCommentUser({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 14.042,
    height: 13.846,
    viewBox: "0 0 14.042 13.846",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "comment-user",
    d: "M7.021,5.851A1.755,1.755,0,1,1,8.776,4.1,1.755,1.755,0,0,1,7.021,5.851ZM5.247,8.922a1.862,1.862,0,0,1,3.547,0,.585.585,0,1,0,1.134-.293,3.032,3.032,0,0,0-5.814,0,.585.585,0,1,0,1.133.293Zm1.779,4.924a1.176,1.176,0,0,1-.783-.3L4.05,11.7H2.34A2.34,2.34,0,0,1,0,9.361V2.34A2.34,2.34,0,0,1,2.34,0H11.7a2.34,2.34,0,0,1,2.34,2.34V9.361A2.34,2.34,0,0,1,11.7,11.7H10.032L7.781,13.562a1.135,1.135,0,0,1-.755.284ZM2.34,1.17A1.17,1.17,0,0,0,1.17,2.34V9.361a1.17,1.17,0,0,0,1.17,1.17H4.265a.585.585,0,0,1,.377.137l2.367,2,2.441-2a.585.585,0,0,1,.373-.134H11.7a1.17,1.17,0,0,0,1.17-1.17V2.34A1.17,1.17,0,0,0,11.7,1.17Z",
    fill: "#23bee3"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCommentUser);
export default __webpack_public_path__ + "static/media/comment-user.94b2a5f13aeb0a890c4d1a5ae7c1860d.svg";
export { ForwardRef as ReactComponent };